import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

import { NOTICE_IMPRESSION, NOTICE_CLICK } from 'lib/analytics/events';

import Search from 'models/search';

const propTypes = {
  dismissTimePickerPrompt: PropTypes.func.isRequired,
  timePickerPromptDismissed: PropTypes.bool.isRequired,
  trackEvent: PropTypes.func.isRequired,
  currentSearch: PropTypes.instanceOf(Search).isRequired,
};

const SelectTimeToolTip = ({
  dismissTimePickerPrompt,
  timePickerPromptDismissed,
  trackEvent,
  currentSearch,
}) => {
  const trackNoticeEvent = useCallback((event) => {
    trackEvent({
      ...event,
      name: 'ChangeTimeNotice',
      position: '0',
    });
  }, [trackEvent]);

  const onVisibilityChange = useCallback((isVisible) => {
    if (isVisible) {
      trackNoticeEvent(NOTICE_IMPRESSION);
    }
  }, [trackNoticeEvent]);

  const onClick = useCallback((e) => {
    e.preventDefault();
    dismissTimePickerPrompt();
    trackNoticeEvent(NOTICE_CLICK);
  }, [dismissTimePickerPrompt, trackNoticeEvent]);

  const { isMonthlySearch, isEventSearch, isPackageSearch } = currentSearch;
  if (timePickerPromptDismissed || isMonthlySearch || isEventSearch || isPackageSearch) {
    return null;
  }

  return (
    <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
      <div className="tooltip-prompt time-picker-prompt">
        <div className="padding-horizontal-10 padding-vertical-15 text-size-12 text-color-white">
          <span className="iconified-font iconified-clock text-size-16 iconified-space-right" />
          <span className="prompt-message">Select the start time and end time <br className="visible-xs" />for your booking here.</span>
          <span className="iconified-font iconified-x text-size-14 iconified-space-left clickable" onClick={onClick} />
        </div>
      </div>
    </VisibilitySensor>
  );
};

SelectTimeToolTip.propTypes = propTypes;
export default SelectTimeToolTip;
